import type { AiAppCenterModule } from '../types'

export const xuanxueModule: AiAppCenterModule = {
  key: 'xuanxue',
  label: '玄学',
  desc: '传统命理与民俗文化服务：师傅/机构 · 服务目录 · 订单 · 会员知命卡 · 签到修为 · 课程 · 解梦词条',
  path: '/xuanxue',
  homePath: '/xuanxue/dream/dream-entry',
  icon: 'ep:magic-stick',
  color: '#9A3B2E'
}
